import { render, staticRenderFns } from "./InviteStartup.vue?vue&type=template&id=02df8459&scoped=true&"
import script from "./InviteStartup.vue?vue&type=script&setup=true&lang=js&"
export * from "./InviteStartup.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02df8459",
  null
  
)

export default component.exports